import React from "react";
import "../stylesheets/lightboxHeader.scss";

const LightboxHeader = React.memo(({onClose}) => 
  <div className="immersive-lightbox-header">
    <div className="immersive-lightbox--exit-arrow" onClick={onClose}></div>
    <div className="immersive-lightbox--header-logo-desktop ">
      <GShowLogoSVG width="124px" height="34px" />
    </div>
    <div className="immersive-lightbox--header-logo-mobile ">
      <GShowLogoSVG width="90px" height="28px" />
    </div>
  </div>
)

const GShowLogoSVG = React.memo(({width, height}) =>
  <svg xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 160"
    width={width}
    height={height}>
      <title>gshow.com</title>
      <path fill="#FFF" fillRule="evenodd" d="M83.84 81.556H55.83c-3.102 0-5.775 1.1-7.943 3.27-2.172
      2.156-3.27 4.846-3.27 7.94 0 3.114 1.102 5.766 3.278 7.922 2.168 2.136 4.84 3.223 7.937
      3.223H67.2c-1.746 2.488-3.867 4.57-6.336 6.21-3.47 2.34-7.248 3.518-11.23 3.518-6.992
      0-12.726-2.34-17.53-7.11-4.804-4.79-7.14-10.52-7.14-17.52 0-6.98 2.334-12.71 7.137-17.462
      4.806-4.753 10.54-7.074 17.533-7.074 5.967 0 11.05 1.824 15.543 5.58 2.315 1.936
      5.01 2.912 8.005 2.912 3.474 0 6.468-1.216 8.875-3.61 2.425-2.395 3.656-5.38 3.656-8.86
      0-3.925-1.56-7.185-4.647-9.746C71.933 43.214 61.35 39.4 49.645 39.4c-13.87 0-25.74
      4.82-35.257 14.332C4.832 63.312 0 75.176 0 89.047c0 13.89 4.832 25.762 14.36 35.295
      9.528 9.533 21.397 14.37 35.273 14.37 11.868 0 22.512-4.736 31.632-14.075 9.113-9.32
      13.743-20.088 13.743-31.986 0-3.065-1.102-5.71-3.27-7.862-2.168-2.155-4.814-3.242-7.882-3.242l-.015.01zM149.6
      80.1c-2.168-.994-4.948-2.137-8.342-3.426-7.492-2.868-11.236-5.618-11.236-8.253 0-3.278 2.136-4.917 6.408-4.917
      2.4 0 6.262 1.142 11.588 3.426 5.324 2.278 9.072 3.42 11.235 3.42 3.337 0 6.12-1.142 8.342-3.426 2.223-2.285
      3.335-5.094 3.335-8.432 0-6.5-4.127-11.623-12.378-15.37-6.496-2.93-13.432-4.403-20.805-4.403-9.774 0-17.968
      2.597-24.583 7.81-7.257 5.618-10.884 13.19-10.884 22.75 0 7.423 2.775 13.668 8.323 18.697 4.03 3.63 10.217
      7.055 18.57 10.28l1.842.7c9.052 3.444 13.577 6.667 13.577 9.652 0 3.867-2.628 5.783-7.883 5.783-2.92
      0-7.288-1.382-13.1-4.126-5.813-2.764-10.178-4.127-13.1-4.127-3.27 0-5.928 1.345-7.973 4.034-1.87 2.395-2.802
      5.287-2.802 8.695 0 7.183 4.303 12.728 12.905 16.597 6.67 2.984 14.074 4.476 22.21 4.476 10.417 0 19.225-2.726
      26.423-8.18 7.9-6.023 11.85-14.11 11.85-24.24
      0-6.854-2.37-12.62-7.11-17.3-3.454-3.388-8.923-6.796-16.414-10.185l.002.062zm85.324-40.31c-10.473 0-18.58
      2.984-24.315 8.956v-28.02c0-13.814-4.74-20.726-14.22-20.726-9.426 0-14.148 6.908-14.148 20.727v97.135c0 13.76
      4.703 20.64 14.128 20.64 9.48 0 14.22-6.876 14.22-20.64V85.46c0-14.406 5.016-21.61 15.048-21.61 6.118 0 10.344
      2.256 12.677 6.762 1.69 3.282 2.536 8.344 2.536 15.197v32.052c0 13.76 4.74 20.64 14.256 20.64 9.5 0
      14.257-6.876 14.257-20.64v-40.66c0-24.94-11.5-37.413-34.504-37.413h.062zm273.462
      4.74c-2.407-2.576-5.622-3.866-9.66-3.866-6.668 0-11.12 3.895-13.345 11.68l-14.92
      52.873-12.905-50.853c-2.228-8.783-7.025-13.17-14.4-13.17-6.723 0-11.077
      4.273-13.08 12.82l-12.108 51.994-14.92-51.82c-2.68-9.246-7.55-13.875-14.568-13.875-4.025 0-7.314
      1.317-9.83 3.953-2.518 2.634-3.767 6-3.767 10.098 0 2.168.533 4.716 1.58 7.64l22.47 62.885c3.51
      9.836 9.223 14.754 17.123 14.754 8.544 0 13.927-4.623 16.15-13.87L443.193 79.8l11.704 45.076c2.517
      9.855 8.212 14.774 17.105 14.774 7.496 0 12.86-4.624 16.15-13.87l21.753-61.914c1.397-3.98 2.095-7.074
      2.095-9.303.018-4.09-1.176-7.424-3.583-10.003l-.033-.033zM326.05 39.17c-13.93 0-25.813 4.92-35.642
      14.756-9.83 9.836-14.74 21.724-14.74 35.657 0 13.995 4.905 25.897 14.707 35.704 9.792 9.804 21.69 14.71
      35.68 14.71 13.982 0 25.882-4.904 35.686-14.71 9.8-9.808 14.703-21.71 14.703-35.705
      0-13.992-4.906-25.894-14.704-35.7-9.805-9.81-21.703-14.713-35.69-14.713zm22.655 72.67c-6.173
      6.17-13.752 9.3-22.525 9.3-8.773 0-16.334-3.133-22.47-9.31-6.137-6.17-9.242-13.742-9.242-22.51
      0-1.97 1.586-3.555 3.555-3.555 1.97 0 3.555 1.584 3.555 3.555 0 6.908 2.345 12.618 7.177 17.48 4.814
      4.846 10.528 7.204 17.417 7.204 6.91 0 12.64-2.376 17.49-7.22 4.852-4.864 7.222-10.575 7.222-17.483 0-1.97
      1.58-3.555 3.546-3.555 1.966 0 3.564 1.584 3.564 3.555-.018 8.77-3.16 16.34-9.333 22.51l.045.03z">
      </path>
  </svg>
)

export default LightboxHeader;